import api from './axiosClient'
import {
    GetIndustriesOverviewResponse,
    GetIndustryPageResponse,
    ResolveIndustryPathResponse,
} from '../../proto/generated/screener'

const protobufHeaders = {
    Accept: 'application/x-protobuf',
}

const decodeArrayBuffer = <T>(decode: (input: Uint8Array) => T) =>
    (response: { data: ArrayBuffer }) => decode(new Uint8Array(response.data))

export type GetIndustryPageParams = {
    path: string
    page?: number
    pageSize?: number
    sortField?: string
    sortDirection?: string
}

export const getIndustriesOverview = async (): Promise<GetIndustriesOverviewResponse> => {
    const response = await api.get('/screener/industries/overview', {
        headers: protobufHeaders,
        responseType: 'arraybuffer',
    })
    return decodeArrayBuffer(GetIndustriesOverviewResponse.decode)(response)
}

export const getIndustryPage = async ({
    path,
    page = 0,
    pageSize = 50,
    sortField,
    sortDirection,
}: GetIndustryPageParams): Promise<GetIndustryPageResponse> => {
    const params: Record<string, string | number> = { path, page, pageSize }
    if (sortField) params.sortField = sortField
    if (sortDirection) params.sortDirection = sortDirection

    const response = await api.get('/screener/industries/page', {
        params,
        headers: protobufHeaders,
        responseType: 'arraybuffer',
    })
    return decodeArrayBuffer(GetIndustryPageResponse.decode)(response)
}

export const resolveIndustryPath = async (code: string): Promise<ResolveIndustryPathResponse> => {
    const response = await api.get('/screener/industries/resolve-path', {
        params: { code },
        headers: protobufHeaders,
        responseType: 'arraybuffer',
    })
    return decodeArrayBuffer(ResolveIndustryPathResponse.decode)(response)
}
